export default __webpack_public_path__ + "static/Plots0014-6356118825b049a007291e4d7a27389b.jpg";